import { ConcreteEncodable } from "./ConcreteEncodable";

import { BenchmarkPairConfigImplEncoder } from "../../encoder/BenchmarkPairConfigImplEncoder";

import * as CubiqTS from "../../index";
import { BenchmarkPairConfig } from "../BenchmarkPairConfig";

export class BenchmarkPairConfigImpl extends ConcreteEncodable implements BenchmarkPairConfig {
  public static enType: string = "com.bcdfx.model.BenchmarkPairConfigImpl";

  /*FID=1*/
  public bmCode: string;
  /*FID=2*/
  public base: string;
  /*FID=3*/
  public nonBase: string;
  /*FID=4*/
  public warningLevel: CubiqTS.BigNumber | null = null;
  /*FID=5*/
  public alertLevel: CubiqTS.BigNumber | null = null;
  /*FID=6*/
  public spawnedCcyCd: string;
  /*FID=7*/
  public fwdWarningLevel: CubiqTS.BigNumber | null = null;
  /*FID=8*/
  public fwdAlertLevel: CubiqTS.BigNumber | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=10010*/
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BenchmarkPairConfigImplEncoder.Instance;
    this.setEncodableType(BenchmarkPairConfigImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BenchmarkPairConfigImpl[" +
      "bmCode=" +
      this.bmCode +
      "base=" +
      this.base +
      "nonBase=" +
      this.nonBase +
      "warningLevel=" +
      this.warningLevel +
      "alertLevel=" +
      this.alertLevel +
      "spawnedCcyCd=" +
      this.spawnedCcyCd +
      "fwdWarningLevel=" +
      this.fwdWarningLevel +
      "fwdAlertLevel=" +
      this.fwdAlertLevel +
      "messageId=" +
      this.messageId +
      "sessionOnly=" +
      this.sessionOnly +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
